import { IPhone } from '@Components/index'
import { PhoneType } from '@Enums/index'

export class Phone {

  public static createDefaultPhone(type: PhoneType = PhoneType.Mobil): IPhone {
		return {id: '-1', number: '', iso: 'fr', type: type, error: false}
	}
}